
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/product-details/[id]",
      function () {
        return require("private-next-pages/shopping/product-details/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopping/product-details/[id]"])
      });
    }
  